import { render, staticRenderFns } from "./BigTeaserSection.vue?vue&type=template&id=2835d35a&"
import script from "./BigTeaserSection.vue?vue&type=script&lang=js&"
export * from "./BigTeaserSection.vue?vue&type=script&lang=js&"
import style0 from "./BigTeaserSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports